import Box from "@mui/material/Box";
import ImageHero from "../../assets/images/hero.jpg";
import ImageJoin from "../../assets/images/join4.jpg";
import ImageHeroOrder from "../../assets/images/heros/order.jpg";
import styles from "./styles.module.css";
import {
  Button,
  Card,
  CardContent,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Collapse,
} from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import IconLogoColour from "../../components/IconLogoColour/IconLogoColour.jsx";
import IconTbana from "../../components/IconTbana/IconTbana.jsx";
import Grid from "@mui/material/Grid";
import IconSchedule from "@mui/icons-material/Schedule";
import IconPlace from "@mui/icons-material/Place";
import IconGroups from "@mui/icons-material/Groups";
import IconSportsGymnastics from "@mui/icons-material/SportsGymnastics";
import IconEmergency from "@mui/icons-material/Emergency";
import IconLoyalty from "@mui/icons-material/Loyalty";
import IconCreditCardOff from "@mui/icons-material/CreditCardOff";
import IconCheckroom from "@mui/icons-material/Checkroom";
import IconPayment from "@mui/icons-material/Payment";
import IconArrowOutward from "@mui/icons-material/ArrowOutward";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { ROUTES } from "../../routes";
import ImageCarousel from "../../components/ImageCarousel/ImageCarousel";
import { useAppContext } from "../../components/AppContext/AppContext";
import Alerts from "../../components/Alerts/Alerts";
import { apiEventList, apiHistoryEventGroupList } from "../../api";
import { EventType, TRANSPORT_MODE_ICON, Module } from "../../enums";
import { capitalizeFirstLetter } from "../../utils/string";
import EventCalendar from "../../components/EventCalendar/EventCalendar";
import Map from "../../components/Map/Map";
import { LoaderClip } from "../../components/LoaderClip/LoaderClip";
import markdown from "@wcj/markdown-to-html";
import Pagination from "@mui/material/Pagination";
import { API_HISTORY_EVENT_LIST_PAGE_SIZE } from "../../consts";
import { DynamicIcon } from "../../components/DynamicIcon/DynamicIcon";
import Hero from "../../components/Hero/Hero";
import { languageToLocale } from "../../utils/locale";

const BACKEND_BASE_URL = new URL(process.env.REACT_APP_TOWERS_API_URL).origin;
const ORG_BASE_URL = new URL(process.env.REACT_APP_ORG_BASE_URL).origin;

function HomePage() {
  const [t, i18n] = useTranslation("common");

  const { user, messages, rehearsal, setRehearsal } = useAppContext();

  const theme = useTheme();
  const timelineMatches = useMediaQuery(theme.breakpoints.up("md"));

  const [historyEventsPage, setHistoryEventsPage] = React.useState(1);
  const [historyEvents, setHistoryEvents] = React.useState(undefined);

  const [highligtedEvent, setHighlightedEvent] = React.useState(undefined);

  React.useEffect(() => {
    apiHistoryEventGroupList(historyEventsPage).then((response) => {
      if (response.status === 200) {
        setHistoryEvents(response.data);
      }
    });
  }, [setHistoryEvents, historyEventsPage, i18n.resolvedLanguage]);

  React.useEffect(() => {
    apiEventList().then((response) => {
      if (response.status === 200) {
        setRehearsal(
          response.data.results.find((event: any) => {
            return (
              (event.type === EventType.REHEARSAL ||
                event.type === EventType.PERFORMANCE) &&
              new Date(event.time_to) >= new Date()
            );
          }),
        );
      }
    });
  }, [setRehearsal, i18n.resolvedLanguage]);

  React.useEffect(() => {
    apiEventList(1, 1, undefined, undefined, undefined, undefined, undefined, [
      EventType.PERFORMANCE,
    ]).then((response) => {
      if (response.status === 200 && response.data.results.length > 0) {
        setHighlightedEvent(response.data.results[0]);
      }
    });
  }, [setHighlightedEvent, i18n.resolvedLanguage]);

  return (
    <>
      <Box component="section" className={styles.hero}>
        <Box
          component="section"
          className={styles.heroInner}
          sx={{
            marginTop: { xs: "56px", md: "65px" },
            padding: {
              xs: messages ? "32px 16px 64px 16px" : "64px 16px",
              md: messages ? "64px 16px 132px 16px" : "132px 16px",
            },
          }}
        >
          <Container
            maxWidth="xl"
            sx={{
              position: "relative",
            }}
          >
            <Alerts />
            <Grid
              container
              spacing={{ xs: 2, md: 4 }}
              sx={{ textAlign: { xs: "center", md: "left" } }}
              className={styles.heroGrid}
            >
              <Grid
                size={{ xs: 12, md: 6 }}
                sx={{ marginBottom: { xs: "32px", md: "0" } }}
              >
                <IconLogoColour />
                <Typography
                  variant="h3"
                  fontWeight="700"
                  className={styles.heroTitle}
                >
                  {t("pages.home-hero.title")}
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight="700"
                  className={styles.heroSubtitle}
                >
                  {t("pages.home-hero.subtitle")}
                </Typography>
                <Typography variant="h6" className={styles.heroSubtitle}>
                  {t("pages.home-hero.subtitle2")}
                </Typography>
                {!user && (
                  <Button
                    variant="outlined"
                    href={ROUTES["user-join"].path}
                    target={"_self"}
                    className={styles.heroButton}
                    disableElevation
                  >
                    {t("pages.home-join.list.button-join")}
                  </Button>
                )}
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box
                  sx={{ height: { xs: "300px", md: "500px" } }}
                  className={styles.heroImage}
                  style={{ backgroundImage: "url(" + ImageHero + ")" }}
                />
              </Grid>
            </Grid>
          </Container>
          <Box
            className={styles.carouselTop}
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            <ImageCarousel dense={false} />
          </Box>
        </Box>
      </Box>
      <Collapse in={highligtedEvent} timeout="auto" unmountOnExit>
        {highligtedEvent && (
          <Hero
            title={highligtedEvent.title}
            subtitle={new Date(highligtedEvent.time_from).toLocaleDateString(
              languageToLocale(i18n.resolvedLanguage).code,
              {
                day: "numeric",
                month: "long",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              },
            )}
            hero={
              highligtedEvent.picture &&
              BACKEND_BASE_URL + highligtedEvent.picture.medium
            }
            eventTheme={highligtedEvent.theme}
            content={
              <Box>
                <Typography
                  variant="h4"
                  className={styles.heroSectionSubtitle}
                  marginTop="12px"
                >
                  {highligtedEvent.description}
                </Typography>
                <Grid size={12} marginTop="24px">
                  <Stack
                    direction="row"
                    spacing={2}
                    className={styles.joinButtons}
                  >
                    <Button
                      variant="contained"
                      href={
                        (highligtedEvent.module === Module.ORG
                          ? ORG_BASE_URL
                          : "") +
                        ROUTES["calendar-event"].path
                          .replace(
                            ":year",
                            highligtedEvent.time_from.slice(0, 4),
                          )
                          .replace(
                            ":month",
                            highligtedEvent.time_from.slice(5, 7),
                          )
                          .replace(
                            ":day",
                            highligtedEvent.time_from.slice(8, 10),
                          )
                          .replace(":code", highligtedEvent.code)
                      }
                      disableElevation
                    >
                      {t("pages.home-highlight.button-info")}
                      {highligtedEvent.module === Module.ORG && (
                        <IconArrowOutward className={styles.joinExternalIcon} />
                      )}
                    </Button>
                  </Stack>
                </Grid>
              </Box>
            }
          />
        )}
      </Collapse>
      <Box
        component="section"
        className={styles.rehearsals}
        pt={{ xs: 5, md: 8 }}
        pb={{ xs: 5, md: 8 }}
        pl={{ xs: 1, lg: 0 }}
        pr={{ xs: 1, lg: 0 }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            fontWeight="700"
            className={styles.rehearsalsTitle}
          >
            {t("pages.home-rehearsals.title")}
          </Typography>
          <Grid container spacing={4} className={styles.rehearsalsGrid}>
            <Grid
              size={{ xs: 12, md: 5 }}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <React.Fragment>
                <CardContent className={styles.rehearsalsCard}>
                  <IconSchedule className={styles.rehearsalsIcon} />
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="600"
                      className={styles.rehearsalsCardTitle}
                    >
                      {rehearsal
                        ? t("pages.home-rehearsals.box1.title-rehearsal")
                        : t("pages.home-rehearsals.box1.title")}
                    </Typography>
                    <Typography className={styles.rehearsalsCardText}>
                      {rehearsal
                        ? capitalizeFirstLetter(
                            new Date(rehearsal.time_from).toLocaleDateString(
                              i18n.resolvedLanguage,
                              { weekday: "long" },
                            ),
                          ) +
                          " " +
                          capitalizeFirstLetter(
                            new Date(rehearsal.time_from).toLocaleDateString(
                              i18n.resolvedLanguage,
                              { day: "numeric", month: "long" },
                            ),
                          ) +
                          " " +
                          t("pages.home-rehearsals.box1.text1-from") +
                          " " +
                          new Date(rehearsal.time_from).toLocaleTimeString(
                            i18n.resolvedLanguage,
                            {
                              hour12: false,
                              hour: "2-digit",
                              minute: "2-digit",
                            },
                          ) +
                          " " +
                          t("pages.home-rehearsals.box1.text1-to") +
                          " " +
                          new Date(rehearsal.time_to).toLocaleTimeString(
                            i18n.resolvedLanguage,
                            {
                              hour12: false,
                              hour: "2-digit",
                              minute: "2-digit",
                            },
                          )
                        : t("pages.home-rehearsals.box1.text1")}
                    </Typography>
                    <Typography className={styles.rehearsalsCardText2}>
                      {t("pages.home-rehearsals.box1.text2")}
                    </Typography>
                  </Box>
                </CardContent>
              </React.Fragment>
              <React.Fragment>
                <CardContent className={styles.rehearsalsCard}>
                  <IconPlace className={styles.rehearsalsIcon} />
                  <Box>
                    <Typography
                      variant="h5"
                      fontWeight="600"
                      className={styles.rehearsalsCardTitle}
                    >
                      {t("pages.home-rehearsals.box2.title")}
                    </Typography>
                    <Typography className={styles.rehearsalsCardText}>
                      {rehearsal ? (
                        rehearsal.location ? (
                          <>
                            {rehearsal.location.name}
                            {rehearsal.location.connections.length > 0 && (
                              <Box
                                component="span"
                                className={styles.rehearsalsCardTransportText}
                              >
                                {" ("}
                                {
                                  TRANSPORT_MODE_ICON[
                                    rehearsal.location.connections[0].type
                                  ]
                                }
                                {rehearsal.location.connections[0].name}
                                {")"}
                              </Box>
                            )}
                          </>
                        ) : (
                          t("pages.home-rehearsals.box2.text1-location")
                        )
                      ) : (
                        <>
                          {t("pages.home-rehearsals.box2.text1-1")}
                          {" ("}
                          <IconTbana />
                          {t("pages.home-rehearsals.box2.text1-2")}
                          {")"}
                        </>
                      )}
                    </Typography>
                    {rehearsal &&
                    rehearsal.location &&
                    rehearsal.location.description ? (
                      <Typography className={styles.rehearsalsCardText2}>
                        {rehearsal.location.description}
                      </Typography>
                    ) : !rehearsal ? (
                      <Typography className={styles.rehearsalsCardText2}>
                        {t("pages.home-rehearsals.box2.text2")}
                      </Typography>
                    ) : undefined}
                  </Box>
                </CardContent>
              </React.Fragment>
              {rehearsal && (
                <React.Fragment>
                  <CardContent className={styles.mapCard}>
                    <Map
                      location={rehearsal.location}
                      coordinates={
                        rehearsal.location
                          ? [
                              rehearsal.location.coordinate_lat,
                              rehearsal.location.coordinate_lon,
                            ]
                          : [59.3576, 17.9941]
                      }
                      connections={
                        rehearsal.location && rehearsal.location.connections
                      }
                      eventType={rehearsal.type}
                      eventTheme={rehearsal.theme}
                    />
                  </CardContent>
                </React.Fragment>
              )}
            </Grid>
            <Grid
              size={{ xs: 12, md: 7 }}
              display={{ xs: "none", md: "initial" }}
              className={styles.calendarBox}
            >
              <Card variant="outlined" className={styles.calendarCard}>
                <EventCalendar compact={true} />
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        component="section"
        className={styles.join}
        pt={{ xs: 5, md: 8 }}
        pb={{ xs: 5, md: 8 }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid size={4} sx={{ display: { xs: "none", md: "block" } }}>
              <Box
                className={styles.joinImage}
                style={{ backgroundImage: "url(" + ImageJoin + ")" }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 8 }}>
              <Typography
                variant="h4"
                fontWeight="700"
                className={styles.joinTitle}
              >
                {t("pages.home-join.title")}
              </Typography>
              <Grid container spacing={1} className={styles.joinGrid}>
                <Grid size={12}>
                  <Typography
                    variant="h5"
                    fontWeight="700"
                    className={styles.joinListTitle}
                  >
                    {t("pages.home-join.list.title")}
                  </Typography>
                </Grid>
                <Grid size={12} className={styles.joinList}>
                  <List dense={true}>
                    <ListItem>
                      <ListItemIcon>
                        <IconGroups />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("pages.home-join.list.item-1.title")}
                        secondary={
                          t("pages.home-join.list.item-1.subtitle")
                            ? t("pages.home-join.list.item-1.subtitle")
                            : null
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <IconSportsGymnastics />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("pages.home-join.list.item-2.title")}
                        secondary={
                          t("pages.home-join.list.item-2.subtitle")
                            ? t("pages.home-join.list.item-2.subtitle")
                            : null
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <IconEmergency />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("pages.home-join.list.item-3.title")}
                        secondary={
                          t("pages.home-join.list.item-3.subtitle")
                            ? t("pages.home-join.list.item-3.subtitle")
                            : null
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <IconLoyalty />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("pages.home-join.list.item-4.title")}
                        secondary={
                          t("pages.home-join.list.item-4.subtitle")
                            ? t("pages.home-join.list.item-4.subtitle")
                            : null
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <IconCreditCardOff />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("pages.home-join.list.item-5.title")}
                        secondary={
                          t("pages.home-join.list.item-5.subtitle")
                            ? t("pages.home-join.list.item-5.subtitle")
                            : null
                        }
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid size={12}>
                  <Typography
                    variant="h5"
                    fontWeight="700"
                    className={styles.joinListTitle}
                  >
                    {t("pages.home-join.list-like.title")}
                  </Typography>
                </Grid>
                <Grid size={12} className={styles.joinList}>
                  <List dense={true}>
                    <ListItem>
                      <ListItemIcon>
                        <IconCheckroom />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("pages.home-join.list-like.item-1.title")}
                        secondary={
                          t("pages.home-join.list-like.item-1.subtitle")
                            ? t("pages.home-join.list-like.item-1.subtitle")
                            : null
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <IconPayment />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("pages.home-join.list-like.item-2.title")}
                        secondary={
                          t("pages.home-join.list-like.item-2.subtitle")
                            ? t("pages.home-join.list-like.item-2.subtitle")
                            : null
                        }
                      />
                    </ListItem>
                  </List>
                </Grid>
                {!user && (
                  <Grid size={12}>
                    <Stack
                      direction="row"
                      spacing={2}
                      className={styles.joinButtons}
                    >
                      <Button
                        variant="contained"
                        href={ROUTES["user-join"].path}
                        target={"_self"}
                        disableElevation
                      >
                        {t("pages.home-join.list.button-join")}
                      </Button>
                    </Stack>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        component="section"
        className={styles.timeline}
        pt={{ xs: 5, md: 8 }}
        pb={{ xs: 5, md: 8 }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            fontWeight="700"
            className={styles.timelineTitle}
          >
            {t("pages.home-timeline.title")}
          </Typography>
          <Grid
            container
            spacing={2}
            direction="column"
            className={styles.timelineGrid}
          >
            {historyEvents && historyEvents.results.length > 0 ? (
              <Timeline
                position={timelineMatches ? "alternate" : "right"}
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                }}
              >
                {historyEvents.results.map((historyEvent: any) => {
                  return (
                    <TimelineItem key={historyEvent.id}>
                      {timelineMatches && (
                        <TimelineOppositeContent
                          sx={{ m: "auto 0" }}
                          align="right"
                          variant="body2"
                          color="textSecondary"
                        >
                          {capitalizeFirstLetter(
                            new Date(historyEvent.date).toLocaleDateString(
                              i18n.resolvedLanguage,
                              {
                                month: "long",
                                year: "numeric",
                              },
                            ),
                          )}
                        </TimelineOppositeContent>
                      )}
                      <TimelineSeparator>
                        <TimelineConnector />
                        <TimelineDot
                          color="primary"
                          style={{ boxShadow: "none" }}
                          className={styles.timetableIcon}
                        >
                          <DynamicIcon iconName={historyEvent.icon.code} />
                        </TimelineDot>
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent sx={{ py: "12px", px: 2 }}>
                        {!timelineMatches && (
                          <Typography variant="body2" color="textSecondary">
                            {capitalizeFirstLetter(
                              new Date(historyEvent.date).toLocaleDateString(
                                i18n.resolvedLanguage,
                                {
                                  month: "long",
                                  year: "numeric",
                                },
                              ),
                            )}
                          </Typography>
                        )}
                        <Typography
                          variant="h6"
                          fontWeight={600}
                          className={styles.timelineItemTitle}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: markdown(historyEvent.title).toString(),
                            }}
                          ></div>
                        </Typography>
                        <Typography
                          variant="body1"
                          className={styles.timelineItemDescription}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: markdown(
                                historyEvent.description,
                              ).toString(),
                            }}
                          ></div>
                        </Typography>
                      </TimelineContent>
                    </TimelineItem>
                  );
                })}
              </Timeline>
            ) : (
              <Box className={styles.loader}>
                <LoaderClip />
              </Box>
            )}
            {historyEvents &&
              historyEvents.results.length > 0 &&
              (historyEventsPage !== 1 ||
                historyEvents.count > historyEvents.results.length) && (
                <Stack
                  alignItems="center"
                  className={styles.timelinePagination}
                >
                  <Pagination
                    page={historyEventsPage}
                    count={Math.ceil(
                      historyEvents.count / API_HISTORY_EVENT_LIST_PAGE_SIZE,
                    )}
                    onChange={(e: any, value: number) =>
                      setHistoryEventsPage(value)
                    }
                  />
                </Stack>
              )}
          </Grid>
        </Container>
      </Box>
      <Box component="section">
        <Hero
          title={t("pages.home-order.title")}
          subtitle={t("pages.home-order.subtitle")}
          hero={ImageHeroOrder}
          content={
            <Box>
              <Grid size={12} marginTop="24px">
                <Stack
                  direction="row"
                  spacing={2}
                  className={styles.joinButtons}
                >
                  <Button
                    variant="contained"
                    href={ROUTES.order.path}
                    disableElevation
                  >
                    {t("pages.home-order.button-order")}
                  </Button>
                </Stack>
              </Grid>
            </Box>
          }
        />
      </Box>
    </>
  );
}

export default HomePage;
